import WaterLevelStackedBarChart from './WaterLevelStackedBarChart ';
import styles from './Well.module.css';

const Well = ({ data }) => {
  return (
    <div>
      <div className={styles.header}>{data?.name}</div>
      <div className={styles.content}>
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-evenly',
            marginTop: '5%',
          }}
        >
          <div>
            <div style={{ fontSize: '22px', fontWeight: 700 }}>
              {Number(data?.lat).toFixed(2)}
            </div>
            <div style={{ height: '5px' }} />
            <div style={{ textAlign: 'center', fontSize: '12px' }}>
              Latitude
            </div>
          </div>
          <div>
            <div style={{ fontSize: '22px', fontWeight: 700 }}>
              {Number(data?.lng).toFixed(2)}
            </div>
            <div style={{ height: '5px' }} />
            <div style={{ textAlign: 'center', fontSize: '12px' }}>
              Longitude
            </div>
          </div>
        </div>
        <hr className={styles.divider} />
        <div style={{ marginLeft: '10px' }}>
          <div style={{ display: 'flex' }}>
            <div style={{ width: '50%', margin: 'auto' }}>
              <div style={{ fontSize: '12px' }}>
                Water Level of {data?.name} well:
              </div>
              <div style={{ height: '8px' }} />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    height: '30px',
                    width: '10px',
                    background:
                      'linear-gradient(360deg, #EEB0B0 0%, #F15033 100%)',
                    marginRight: '5%',
                  }}
                />
                <div style={{ fontSize: '22px', fontWeight: 700 }}>
                  {Number(data?.current_water_level).toFixed(1)} m
                </div>
              </div>
              <div style={{ height: '16px' }} />
              <div style={{ fontSize: '12px' }}>
                Average Water Level of wells:
              </div>
              <div style={{ height: '8px' }} />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    height: '30px',
                    width: '10px',
                    backgroundColor: '#FACDCD',
                    marginRight: '5%',
                  }}
                />
                <div style={{ fontSize: '22px', fontWeight: 700 }}>
                  {Number(data?.average_water_level).toFixed(1)} m
                </div>
              </div>
            </div>
            <div
              style={{
                width: '50%',
                height: '25vh',
                margin: 'auto',
              }}
            >
              <WaterLevelStackedBarChart
                avgWaterLevel={data?.average_water_level}
                wellWaterLevel={data?.current_water_level}
                wellDepth={data?.depth}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              height: '16px',
              fontSize: '13px',
              marginTop: '13%',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ width: '65%' }}>
              Depth of well&nbsp;&nbsp;<b>{data?.depth} m</b>
            </div>
            <div style={{ width: '35%', borderLeft: '1px solid #FFB6B6' }}>
              &nbsp;&nbsp;Yield&nbsp;&nbsp;<b>{data?.yield}</b>
            </div>
          </div>
        </div>
        <hr className={styles.divider} />
        <div
          style={{ display: 'flex', alignItems: 'center', padding: '0 10px' }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <div
              style={{ display: 'flex', width: '70%', alignItems: 'center' }}
            >
              <div style={{ marginRight: '10px' }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.3 16.7L16.7 15.3L13 11.6V7H11V12.4L15.3 16.7ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z"
                    fill="#E87662"
                  />
                </svg>
              </div>
              <div style={{ fontSize: '12px' }}>Hours of operation</div>
            </div>
            <div style={{ width: '30%', textAlign: 'right' }}>
              {data?.pre_monsoon_operation_in_hours} Hrs.
            </div>
          </div>
        </div>
        <hr className={styles.divider} />
        <div
          style={{ display: 'flex', alignItems: 'center', padding: '0 10px' }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <div
              style={{ display: 'flex', width: '70%', alignItems: 'center' }}
            >
              <div style={{ marginRight: '10px' }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.55 18.2L15.725 12H11.725L12.45 6.325L7.825 13H11.3L10.55 18.2ZM8 22L9 15H4L13 2H15L14 10H20L10 22H8Z"
                    fill="#E87662"
                  />
                </svg>
              </div>
              <div style={{ fontSize: '12px' }}>
                Horse Power of the highest pump installed
              </div>
            </div>
            <div style={{ width: '30%', textAlign: 'right' }}>
              {data?.highest_pump_hp} HP
            </div>
          </div>
        </div>
        <hr className={styles.divider} />
        <div
          style={{ display: 'flex', alignItems: 'center', padding: '0 10px' }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <div
              style={{ display: 'flex', width: '70%', alignItems: 'center' }}
            >
              <div style={{ marginRight: '10px' }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2697_583)">
                    <path
                      d="M7.5 9C7.08333 9 6.72917 9.14583 6.4375 9.4375C6.14583 9.72917 6 10.0833 6 10.5C6 10.9167 6.14583 11.2708 6.4375 11.5625C6.72917 11.8542 7.08333 12 7.5 12C7.91667 12 8.27083 11.8542 8.5625 11.5625C8.85417 11.2708 9 10.9167 9 10.5C9 10.0833 8.85417 9.72917 8.5625 9.4375C8.27083 9.14583 7.91667 9 7.5 9ZM7.5 19C7.08333 19 6.72917 19.1458 6.4375 19.4375C6.14583 19.7292 6 20.0833 6 20.5C6 20.9167 6.14583 21.2708 6.4375 21.5625C6.72917 21.8542 7.08333 22 7.5 22C7.91667 22 8.27083 21.8542 8.5625 21.5625C8.85417 21.2708 9 20.9167 9 20.5C9 20.0833 8.85417 19.7292 8.5625 19.4375C8.27083 19.1458 7.91667 19 7.5 19ZM4 6H20C20.2833 6 20.5208 6.09583 20.7125 6.2875C20.9042 6.47917 21 6.71667 21 7V14C21 14.2833 20.9042 14.5208 20.7125 14.7125C20.5208 14.9042 20.2833 15 20 15H4C3.71667 15 3.47917 14.9042 3.2875 14.7125C3.09583 14.5208 3 14.2833 3 14V7C3 6.71667 3.09583 6.47917 3.2875 6.2875C3.47917 6.09583 3.71667 6 4 6ZM5 8V13H19V8H5ZM4 16H20C20.2833 16 20.5208 16.0958 20.7125 16.2875C20.9042 16.4792 21 16.7167 21 17V24C21 24.2833 20.9042 24.5208 20.7125 24.7125C20.5208 24.9042 20.2833 25 20 25H4C3.71667 25 3.47917 24.9042 3.2875 24.7125C3.09583 24.5208 3 24.2833 3 24V17C3 16.7167 3.09583 16.4792 3.2875 16.2875C3.47917 16.0958 3.71667 16 4 16ZM5 18V23H19V18H5Z"
                      fill="#E87662"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2697_583">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div style={{ fontSize: '12px' }}>Name of Village</div>
            </div>
            <div style={{ width: '30%', textAlign: 'right' }}>
              {data?.village_name}
            </div>
          </div>
        </div>
        <hr className={styles.divider} />
        <div
          style={{ display: 'flex', alignItems: 'center', padding: '0 10px' }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <div
              style={{ display: 'flex', width: '70%', alignItems: 'center' }}
            >
              <div style={{ marginRight: '10px' }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8ZM12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18Z"
                    fill="#E87662"
                  />
                </svg>
              </div>
              <div style={{ fontSize: '12px' }}>Year of Construction</div>
            </div>
            <div style={{ width: '30%', textAlign: 'right' }}>
              {data?.construction_year}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Well;
